<template>
  <body>
    <!-- 한국어 -->
    <template v-if="isKorean">
      <h3 class="title">서비스 이용약관</h3>

      <div class="wrapper-paragraph">
        <p class="accent">시행일: 2025년 12월 22일</p>
        <p>
          본 약관은 SconAI(이하 "회사")가 제공하는 SconChat 통역 서비스(이하 "서비스")의
          이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을
          규정함을 목적으로 합니다.
        </p>
      </div>

      <!-- 제1조 -->
      <h4 class="accent section-title">제1조 (목적)</h4>
      <div class="wrapper-paragraph">
        <p>
          본 약관은 회사가 제공하는 서비스 이용과 관련하여 회사와 이용자 간의 권리,
          의무 및 책임사항, 서비스 이용 조건 및 절차 등 기본적인 사항을 규정함을
          목적으로 합니다.
        </p>
      </div>

      <!-- 제2조 -->
      <h4 class="accent section-title">제2조 (용어의 정의)</h4>
      <div class="wrapper-paragraph">
        <p class="accent">· 이용자</p>
        <p>회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</p>

        <p class="accent">· 회원</p>
        <p>개인정보를 제공하고 회원등록을 한 자로서 서비스를 이용할 수 있는 자를 의미합니다.</p>

        <p class="accent">· 비회원</p>
        <p>회원으로 가입하지 않고 서비스를 이용하는 자를 의미합니다.</p>

        <p class="accent">· 콘텐츠</p>
        <p>
          서비스 제공과 관련하여 제공되는 부호, 문자, 음성, 음향, 이미지, 영상 등
          일체의 자료를 의미합니다.
        </p>
      </div>

      <!-- 제3조 -->
      <h4 class="accent section-title">제3조 (약관의 효력 및 변경)</h4>
      <div class="wrapper-paragraph">
        <p>· 본 약관은 서비스를 이용하고자 하는 모든 이용자에게 효력을 가집니다.</p>
        <p>
          · 회사는 약관 내용을 이용자가 쉽게 알 수 있도록 웹사이트 또는 약관 동의
          화면에 게시합니다.
        </p>
        <p>
          · 회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
        </p>
        <p>
          · 약관이 변경되는 경우 시행일 7일 전부터 공지하며, 이용자에게 불리한 변경의
          경우 30일 전 개별 통지합니다.
        </p>
        <p>
          · 이용자가 변경된 약관 시행 이후에도 서비스를 계속 이용할 경우 변경된
          약관에 동의한 것으로 봅니다.
        </p>
      </div>

      <!-- 제4조 -->
      <h4 class="accent section-title">제4조 (서비스의 제공)</h4>
      <div class="wrapper-paragraph">
        <p>· 서비스는 연중무휴 24시간 제공을 원칙으로 합니다.</p>
        <p>
          · 설비 점검, 장애, 운영상 필요에 따라 서비스 제공이 일시 중단될 수 있으며,
          이 경우 사전 또는 사후에 공지합니다.
        </p>
        <p>· 정기 점검 일정은 웹사이트 또는 서비스 화면을 통해 안내합니다.</p>
        <p>· 회사는 서비스의 내용 변경 또는 종료 시 사전에 공지합니다.</p>
      </div>

      <!-- 제5조 -->
      <h4 class="accent section-title">제5조 (이용자의 의무)</h4>
      <div class="wrapper-paragraph">
        <p>
          이용자는 관계 법령, 본 약관, 서비스 이용 안내 및 회사의 공지 사항을
          준수해야 합니다.
        </p>

        <p class="accent">· 금지 행위</p>
        <p>타인의 개인정보 도용 또는 부정 사용</p>
        <p>서비스 운영 방해 행위</p>
        <p>회사 또는 제3자의 명예를 훼손하는 행위</p>
        <p>음란·폭력 등 공서양속에 반하는 정보 유통</p>
        <p>저작권 등 타인의 권리 침해</p>
        <p>서비스의 복제, 역설계, 소스코드 추출 시도</p>
        <p>범죄와 관련된 행위</p>

        <p>
          이용자는 서비스 이용 권한을 타인에게 양도하거나 담보로 제공할 수 없습니다.
        </p>

        <p>
          회사는 이용자가 본 약관 또는 관련 법령을 위반한 경우 서비스 이용을 제한하거나
          계정 사용을 중단할 수 있습니다.
        </p>
      </div>

      <!-- 제6조 -->
      <h4 class="accent section-title">제6조 (회사의 의무)</h4>
      <div class="wrapper-paragraph">
        <p>· 회사는 안정적인 서비스 제공을 위해 노력합니다.</p>
        <p>· 개인정보 보호를 위한 보안 시스템을 구축하고 관련 법령을 준수합니다.</p>
        <p>· 이용자의 정당한 불만에 대해 신속히 처리하고 결과를 안내합니다.</p>
      </div>

      <!-- 제7조 -->
      <h4 class="accent section-title">제7조 (서비스의 중단 및 해지)</h4>
      <div class="wrapper-paragraph">
        <p>· 약관 위반 또는 서비스 운영 방해 시 이용이 제한될 수 있습니다.</p>
        <p>· 국가 비상사태, 설비 장애 등 불가피한 사유로 서비스가 중단될 수 있습니다.</p>
        <p>· 이용자는 언제든지 서비스 이용을 중단하고 탈퇴할 수 있습니다.</p>
      </div>

      <!-- 제8조 -->
      <h4 class="accent section-title">제8조 (개인정보 보호)</h4>
      <div class="wrapper-paragraph">
        <p>
          회사는 관련 법령에 따라 이용자의 개인정보를 보호하며,
          개인정보 처리에 관한 사항은 개인정보처리방침을 따릅니다.
        </p>
      </div>

      <!-- 제9조 -->
      <h4 class="accent section-title">제9조 (면책조항)</h4>
      <div class="wrapper-paragraph">
        <p>· 회사는 법령이 허용하는 범위 내에서 책임을 제한합니다.</p>
        <p>· 천재지변 등 불가항력으로 인한 서비스 중단에 대해 책임을 지지 않습니다.</p>
        <p>· 이용자의 귀책사유로 발생한 손해에 대해 책임을 지지 않습니다.</p>
        <p>· 서비스 이용 결과에 대한 기대 손익에 대해 책임을 지지 않습니다.</p>
        <p>· 이용자 간 또는 제3자와의 분쟁에 개입하지 않습니다.</p>
      </div>

      <!-- 제10조 -->
      <h4 class="accent section-title">제10조 (분쟁 해결)</h4>
      <div class="wrapper-paragraph">
        <p>· 회사와 이용자는 분쟁 해결을 위해 성실히 협의합니다.</p>
        <p>
          · 협의로 해결되지 않을 경우 콘텐츠분쟁조정위원회에 조정을 신청할 수 있습니다.
        </p>
      </div>

      <!-- 제11조 -->
      <h4 class="accent section-title">제11조 (준거법 및 관할)</h4>
      <div class="wrapper-paragraph">
        <p>· 본 약관은 대한민국 법을 준거법으로 합니다.</p>
        <p>· 분쟁에 대한 소송은 민사소송법상의 관할 법원에 제기합니다.</p>
      </div>

      <div class="wrapper-paragraph">
        <p>시행일: 2025년 12월 22일</p>
      </div>
    </template>

    <!-- English (default) -->
    <template v-else>
      <h3 class="title">SconChat Terms of Service</h3>

      <div class="wrapper-paragraph">
        <p class="accent">Last Updated: 11 November 2025</p>
        <p>
          These Terms of Service ("Terms") form a legal agreement between you ("you," "your") and SconAI Inc.
          ("SconAI," "we," "us," or "our"). By accessing or using any of our Services (as defined below),
          registering an account, or simply browsing our Website, you acknowledge that you have read,
          understood, and agree to be bound by these Terms.
        </p>
        <p>These Terms govern your access to and use of SconChat, which includes:</p>
        <p class="small">
          1. The website located at sconchat.com, along with any related subdomains, web pages, or official
          social media accounts (collectively, the "Website"); and
        </p>
        <p class="small">
          2. The products, applications (including mobile apps), and other services provided through the
          Website, our application programming interfaces ("APIs"), or any other means (collectively,
          the "Services").
        </p>
        <p>
          For clarity, any Beta Services offered by SconAI are excluded from the definition of "Services"
          under these Terms.
        </p>
        <p>
          If you subscribe to any paid feature or functionality of the Services for a specific term
          (the "Initial Term"), your subscription will automatically renew for successive periods of the
          same length as the Initial Term, at SconChat's then-current pricing, unless you cancel your
          subscription in accordance with Section 6(a) below.
        </p>
      </div>

      <!-- Section 1 -->
      <h4 class="accent section-title">1. Eligibility and Use Restrictions</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Age Requirement.</p>
        <p>
          You must be at least 18 years old (or the age of legal majority in your jurisdiction) to use the
          Services. Individuals under that age may not access or use the Services under any circumstances.
        </p>

        <p class="accent">(b) Use on Behalf of Others.</p>
        <p>If you access, register for, or use the Services on behalf of another individual or organization:</p>
        <p class="small">(i) every reference to "you" in these Terms (except in Section 1(a)) will include that individual or organization;</p>
        <p class="small">(ii) you confirm that you have full authority to bind that individual or organization to these Terms; and</p>
        <p class="small">(iii) both you and that individual or organization will be jointly responsible for any violation of these Terms.</p>
        <p>
          If you are an organization, you are also responsible for ensuring that your employees, agents, and
          representatives comply with these Terms when using the Services.
        </p>

        <p class="accent">(c) Use Limitations.</p>
        <p>
          Your access to and use of the Services, as well as any resulting Output (as defined below), must
          comply with these Terms at all times. Without limiting the foregoing:
        </p>
        <p class="small">(i) if you use the Services without payment (a "Free User"), you may only do so for non-commercial purposes;</p>
        <p class="small">(ii) if you use the Services under a paid subscription (a "Paid User"), you may use them for commercial purposes.</p>
        <p>In all cases, your use of the Services and any Output must remain consistent with our Prohibited Use Policy.</p>
      </div>

      <!-- Section 2 -->
      <h4 class="accent section-title">2. Personal Data</h4>
      <div class="wrapper-paragraph">
        <p>
          You may provide certain information to SconAI when accessing or using the Services, and we may also
          collect limited information about you as part of your use of the Services. You agree to receive
          communications from SconAI through the Services using the contact details (such as your email
          address) that you provide.
        </p>
        <p>
          You represent and warrant that all information you submit to SconAI in connection with the Services
          is accurate and complete.
        </p>
        <p>
          For details on how we collect, use, store, and protect your personal information, please refer to
          our Privacy Policy, which governs our overall data practices.
        </p>
        <p>
          SconAI does not use or process any interpretation or translation data for the training, development,
          or improvement of its AI models or research purposes.
        </p>
        <p>
          Such data may be recorded and retained only with your separate and explicit consent, and solely for
          the purpose of providing the service output to you (for example, playback or record history features).
        </p>
      </div>

      <!-- Section 3 -->
      <h4 class="accent section-title">3. Accounts</h4>
      <div class="wrapper-paragraph">
        <p>
          Certain features or areas of the Services may require you to create an account. You are responsible
          for all activity that occurs under your account and for keeping your login credentials confidential.
          Your account credentials are personal to you and may not be shared or used by anyone else.
        </p>
        <p>
          You agree to keep your account information accurate and up to date at all times. If you become aware,
          or have reason to believe, that your account has been accessed or used without authorization, you
          must notify SconAI immediately.
        </p>
        <p>
          You are solely responsible for maintaining the security of your account. In the event your account
          is terminated or closed for any reason, any unused service credits (including character credits)
          linked to that account will be permanently forfeited.
        </p>
      </div>

      <!-- Section 4 -->
      <h4 class="accent section-title">4. Content and User Voice Models</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Inputs and Outputs</p>
        <p>
          You may submit or transmit data and other materials to the Services ("Input"). Based on your Input,
          the Services may return audio output generated by one or more synthetic voice models or text output
          generated by one or more large language models ("Output").
        </p>
        <p>Together, the Input and Output are referred to as "Content."</p>
        <p>
          Input may include, for example, voice recordings, text descriptions, or any other content you
          provide through the Services.
        </p>
        <p>
          Your use of the Services—including providing Input and using Output—must always comply with these
          Terms and our Prohibited Use Policy.
        </p>
        <p>
          In some cases, you may be allowed to download Output for your own use, provided that any such use
          remains subject to these Terms and the Prohibited Use Policy.
        </p>
        <p>
          Content generated or transmitted within a shared interpretation or translation session may be
          visible or accessible to other participants in that session. Those participants are limited to the
          individuals or entities you have expressly authorized or invited to join the same session.
        </p>
        <p>
          You are responsible for managing access permissions and ensuring that only authorized users may
          view or receive your Content.
        </p>
        <p>
          SconAI is not liable for any disclosure, exposure, or sharing of Content that occurs as a result
          of your configuration choices, access permissions, or other user actions within the Services.
        </p>

        <p class="accent">(b) User Voice Models</p>
        <p>
          Certain Services may allow you to create a personalized voice model that can generate synthetic
          audio resembling your own voice or another voice you are legally permitted to share
          ("User Voice Model").
        </p>
        <p>
          Your voice data is used only to reproduce or deliver translation and interpretation audio that
          reflects your natural speaking characteristics within the Service.
        </p>
        <p>
          SconAI does not use or analyze your voice recordings for AI model training, research, or any other
          unrelated purposes.
        </p>
        <p>
          For details on how we collect, store, and delete your recordings, please review the Voice Processing
          Notice in our Privacy Policy.
        </p>
        <p>
          You may directly delete any User Voice Models associated with your account at any time through your
          account settings.
        </p>

        <p class="accent">(c) License to Your Content</p>
        <p>
          By submitting Input, you grant SconAI a limited license to use your Content only as necessary to
          provide the Services to you (including quality control, moderation, and support).
        </p>
        <p>
          We do not use your Content—including voice data, speech, or any identifiable personal information—
          for AI model training, data analysis, or product development unless you give explicit consent for
          that purpose.
        </p>
        <p>This license is:</p>
        <p class="small">· Non-exclusive (you retain ownership of your Content),</p>
        <p class="small">· Royalty-free and fully paid,</p>
        <p class="small">· Worldwide, and</p>
        <p class="small">· Revocable upon account deletion or withdrawal of consent, to the extent permitted by law.</p>

        <p class="accent">(d) License to User Voice Models</p>
        <p>
          If you create a User Voice Model, you grant SconAI permission to use that model only to deliver
          Services to you—for example, to generate audio during translation or playback sessions.
        </p>
        <p>
          We will not use, reproduce, or distribute your User Voice Model for any other purpose without your
          explicit authorization.
        </p>
        <p>
          This license is non-exclusive, royalty-free, and limited in scope to the operation and maintenance
          of the Services you use.
        </p>

        <p class="accent">(e) Necessary Rights</p>
        <p>
          You must ensure that any Content or User Voice Models you provide do not violate the rights of any
          third party. You represent and warrant that you have all rights necessary to grant the licenses
          described in this Section.
        </p>

        <p class="accent">(f) No PHI (Protected Health Information)</p>
        <p>
          You must not submit any Input that includes protected health information (PHI) as defined under the
          U.S. Health Insurance Portability and Accountability Act (HIPAA), unless an applicable Business
          Associate Agreement has been executed with SconAI.
        </p>

        <p class="accent">(g) Moderation</p>
        <p>
          While SconAI is not obligated to monitor all Content, we reserve the right to review, remove, or
          restrict any Content that we determine may violate these Terms or applicable law.
        </p>
        <p>
          We may also suspend or terminate your access to the Services if your Content or behavior is found
          to pose a legal or security risk.
        </p>
        <p>
          As permitted by law, we may cooperate with law enforcement or comply with court orders requiring
          disclosure of Content or account information.
        </p>
      </div>

      <!-- Section 5 -->
      <h4 class="accent section-title">5. Our Intellectual Property</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Ownership</p>
        <p>
          All rights, title, and interest in and to the Services—including all text, graphics, images, videos,
          user interface elements, design, and other materials—are and will remain the exclusive property of
          SconAI and its licensors.
        </p>
        <p>
          Except where these Terms expressly permit otherwise, you are not granted any ownership or
          intellectual property rights in the Services, and all such rights are expressly reserved by SconAI
          and its licensors.
        </p>

        <p class="accent">(b) Limited License</p>
        <p>
          Subject to your continued compliance with these Terms, SconAI grants you a limited, non-exclusive,
          non-transferable, non-sublicensable, and revocable right to access and use SconChat solely for
          purposes permitted by these Terms.
        </p>
        <p>
          Any use of the Services that exceeds this limited authorization—without our prior written consent—
          is strictly prohibited and will automatically terminate your license to use the Services.
        </p>

        <p class="accent">(c) Trademarks</p>
        <p>
          The names "SconAI", "SconChat", and all related logos, product names, and design elements are
          trademarks or trade dress of SconAI. You may not copy, imitate, or use them, in whole or in part,
          without our prior written authorization.
        </p>
        <p>
          All other trademarks, product names, or company names mentioned in connection with the Services are
          the property of their respective owners. Reference to third-party products or services does not
          imply endorsement or sponsorship by SconAI.
        </p>

        <p class="accent">(d) Feedback</p>
        <p>
          You may choose to send us ideas, suggestions, or feedback about SconChat or our other products
          ("Feedback").
        </p>
        <p>
          By submitting Feedback, you agree that SconAI may freely use, copy, modify, or implement such
          Feedback for any purpose—commercial or otherwise—without any obligation to compensate or credit you.
        </p>
        <p>
          Any improvements, enhancements, or new technologies developed based on Feedback will be the
          exclusive property of SconAI, and you agree that such Feedback will be treated as non-confidential.
        </p>
      </div>

      <!-- Section 6 -->
      <h4 class="accent section-title">6. Subscription Services; Payment</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Subscriptions</p>
        <p>
          Certain features of the Services may require you to purchase a recurring subscription
          ("Subscription").
        </p>
        <p>
          Your Subscription will automatically renew at the end of each billing period unless you cancel or
          your Subscription is otherwise terminated. By subscribing, you authorize SconAI to store your
          payment method and automatically charge it for each renewal period, unless you cancel prior to
          renewal.
        </p>
        <p>The length and pricing of your Subscription will be clearly displayed at the time of purchase.</p>
        <p>
          If SconAI is unable to charge your payment method for any reason, we may (i) temporarily suspend
          your access to the Services until payment is successfully processed, or (ii) obtain updated payment
          information through your bank or payment provider to complete the charge.
        </p>
        <p>You may cancel your Subscription at any time through your account settings.</p>
        <p>
          Cancellation will take effect at the end of the current billing period, and no partial refunds will
          be issued for unused time.
        </p>
        <p>
          After cancellation, you will retain access to the paid features until the end of your current
          subscription period.
        </p>
        <p>
          SconAI may update Subscription prices from time to time by posting revised rates through the
          Services. Price changes will apply only to renewal periods after the effective date of the change.
        </p>
        <p>
          If you do not agree to the new pricing, you must cancel at least seven (7) days before the renewal
          date. If you continue without cancellation, your Subscription will automatically renew at the
          updated rate and duration.
        </p>

        <p class="accent">(b) Additional Usage Charges</p>
        <p>
          If your usage exceeds the amount included in your Subscription plan, additional charges may apply
          only if you have expressly agreed in advance to automatic overage billing.
        </p>
        <p>
          In such cases, your authorized payment method will be charged for the additional usage, and you
          may continue using the Services without interruption.
        </p>
        <p>
          If you have not pre-authorized additional usage billing, your access to the relevant Services may
          be temporarily suspended once the included limit is reached, until you either (i) upgrade your plan
          or (ii) manually approve additional usage charges.
        </p>

        <p class="accent">(c) Payment Authorization</p>
        <p>You represent that you have the legal right to use any payment method you provide.</p>
        <p>
          By submitting payment information, you authorize SconAI to charge your payment method for all
          applicable fees, including any updates received from your issuing bank or payment processor.
        </p>
        <p>
          You agree to pay all charges incurred through your account at the rates in effect when the charges
          were made, including applicable taxes or transaction fees required by law.
        </p>
        <p>
          If payment cannot be processed and collection action becomes necessary, you agree to reimburse
          SconAI and its agents for all reasonable recovery costs, including attorney fees and related
          expenses.
        </p>

        <p class="accent">(d) Refunds</p>
        <p>Payments for Services are generally non-refundable.</p>
        <p>
          However, if you request a cancellation within seven (7) days from the date of payment and have not
          yet begun using the Services, you will be eligible for a full refund.
        </p>
        <p>Approved refunds will be processed within thirty (30) days from the date of your valid refund request.</p>
        <p>
          Once service use has begun, or more than seven (7) days have passed since payment, refunds will not
          be issued except where required by applicable law.
        </p>

        <p class="accent">(e) Reservation of Rights</p>
        <p>SconAI reserves the right, with or without prior notice, to:</p>
        <p class="small">· impose conditions or restrictions on promotional offers;</p>
        <p class="small">· refuse or cancel transactions;</p>
        <p class="small">· modify or limit available payment methods; or</p>
        <p class="small">· restrict or terminate access to the Services for any user who violates these Terms or applicable laws.</p>
      </div>

      <!-- Section 7 -->
      <h4 class="accent section-title">7. Copyright Complaints</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Our Policy</p>
        <p>
          In accordance with the Digital Millennium Copyright Act ("DMCA") and other applicable laws, SconAI
          maintains a policy to terminate, in appropriate circumstances, the accounts of users who infringe
          the intellectual property rights of others ("DMCA Policy").
        </p>

        <p class="accent">(b) Reporting Copyright Infringement</p>
        <p>
          If you believe that any material on our Services infringes your copyright, you may submit a DMCA
          Notice to our designated copyright agent using the following contact details:
        </p>
        <p class="small">By Certified Mail:</p>
        <p class="small">SconAI Inc.</p>
        <p class="small">Attn: Copyright Agent</p>
        <p class="small">1111B S Governors Ave STE 40902</p>
        <p class="small">Dover, DE 19904</p>
        <p class="small">By Email: connect@sconai.com</p>
        <p>
          Please review Section 512(c)(3) of the DMCA for the required elements of a valid notification.
          Failure to comply with these requirements may render your notice ineffective.
        </p>
        <p>
          If you knowingly submit a false or misleading claim that any content on our Services is infringing,
          you may be liable for damages and associated costs under applicable law.
        </p>
      </div>

      <!-- Section 8 -->
      <h4 class="accent section-title">8. Third-Party Services and Content</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Third-Party Services</p>
        <p>
          Our Services may interoperate with or depend on third-party technologies and platforms, including
          hosting providers, communication systems, AI model providers, and internet or mobile network
          operators (collectively, "Third-Party Services").
        </p>
        <p>
          These Third-Party Services are operated independently of SconAI, and their performance or
          availability may affect the functionality of our Services.
        </p>

        <p class="accent">(b) Third-Party Content</p>
        <p>
          The Services may include information, links, or integrations related to products, services, or
          events offered by third parties, or may display content made available by third parties
          ("Third-Party Content").
        </p>
        <p>
          Your interactions with any such third parties are solely between you and the third party, and
          SconAI is not responsible for any resulting loss, damage, or dispute.
        </p>

        <p class="accent">(c) No Responsibility for External Content</p>
        <p>
          SconAI does not monitor or endorse Third-Party Services or Third-Party Content and may block or
          disable access to them at any time.
        </p>
        <p>
          Your access to or use of such content may be subject to additional terms, privacy policies, or
          conditions provided by the respective third-party providers.
        </p>
        <p>
          You are responsible for obtaining and maintaining all hardware, network access, and connectivity
          required to use the Services.
        </p>
      </div>

      <!-- Section 9 -->
      <h4 class="accent section-title">9. Indemnification</h4>
      <div class="wrapper-paragraph">
        <p>
          To the fullest extent permitted by law, you agree to indemnify, defend, and hold harmless SconAI,
          its officers, directors, employees, licensors, and agents from and against any claims, damages,
          liabilities, losses, or expenses (including reasonable attorneys' fees) arising out of or related to:
        </p>
        <p class="small">(a) your use of or access to the Services;</p>
        <p class="small">(b) any Content or Feedback you provide;</p>
        <p class="small">(c) your violation of these Terms;</p>
        <p class="small">(d) any infringement or misappropriation of another's rights; or</p>
        <p class="small">(e) your conduct in connection with the Services.</p>
        <p>
          SconAI reserves the right, at its sole discretion, to assume control of the defense of any matter
          otherwise subject to indemnification by you. In that case, you agree to fully cooperate with us in
          the defense or settlement of such claims.
        </p>
        <p>
          This indemnity is in addition to any other indemnities contained in other written agreements
          between you and SconAI.
        </p>
      </div>

      <!-- Section 10 -->
      <h4 class="accent section-title">10. Disclaimers</h4>
      <div class="wrapper-paragraph">
        <p>
          Your use of the SconChat Services (including any beta features, integrations, or third-party
          components) is entirely at your own risk.
        </p>
        <p>
          To the maximum extent permitted by law, the Services and all materials or outputs provided through
          them are offered "as is" and "as available," without any express or implied warranties.
        </p>
        <p>
          SconAI expressly disclaims all warranties, including implied warranties of merchantability, fitness
          for a particular purpose, title, and non-infringement.
        </p>
        <p>
          We do not guarantee that the Services or any outputs will be accurate, complete, uninterrupted,
          secure, or error-free, or that they will meet your expectations.
        </p>
        <p>
          We also cannot guarantee that any content made available through the Services will be free of
          viruses or harmful components.
        </p>
        <p>
          Due to the nature of machine learning, outputs generated through the Services may not be unique
          and may resemble outputs generated for other users.
        </p>
        <p>
          Outputs created for other users do not belong to you, and you have no ownership or rights over them.
        </p>
        <p>
          All disclaimers in these Terms benefit SconAI, its affiliates, licensors, suppliers, and their
          respective successors and assigns.
        </p>
      </div>

      <!-- Section 11 -->
      <h4 class="accent section-title">11. Limitation of Liability</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a)</p>
        <p>
          To the maximum extent permitted by applicable law, SconAI and its affiliates, officers, directors,
          employees, licensors, and agents will not be liable to you under any theory of liability—whether
          based on contract, tort, negligence, warranty, or otherwise—for any indirect, incidental,
          consequential, special, exemplary, or punitive damages, or for any loss of profits, revenue, data,
          goodwill, or other intangible losses, even if SconAI has been advised of the possibility of such
          damages.
        </p>

        <p class="accent">(b)</p>
        <p>
          In no event shall the total liability of SconAI for all claims arising out of or relating to these
          Terms or the Services exceed the greater of:
        </p>
        <p class="small">(i) One Hundred U.S. Dollars (USD $100); or</p>
        <p class="small">
          (ii) the total amount paid by you to SconAI for the Services during the twelve (12) months
          preceding the event giving rise to the claim.
        </p>
      </div>

      <!-- Section 12 -->
      <h4 class="accent section-title">12. Dispute Resolution; Binding Arbitration</h4>
      <div class="wrapper-paragraph">
        <p>
          Please read this section carefully. It requires that most disputes between you and SconAI be
          resolved through binding arbitration, and it limits how relief may be sought.
        </p>
        <p>
          Arbitration means that you and SconAI each waive the right to a trial by jury or to participate
          in a class action. All disputes will be handled on an individual basis only.
        </p>

        <p class="accent">(a) Informal Resolution Before Arbitration</p>
        <p>
          Before initiating arbitration, both you and SconAI agree to first attempt to resolve any dispute
          informally.
        </p>
        <p>If you have a dispute, you must send a written notice describing the issue to:</p>
        <p class="small">SconAI Inc.</p>
        <p class="small">Attn: Legal Department</p>
        <p class="small">1111B S Governors Ave STE 40902</p>
        <p class="small">Dover, DE 19904</p>
        <p class="small">Email: connect@sconai.com</p>
        <p>
          If SconAI has a dispute with you, we will send notice to the email address associated with your
          account.
        </p>
        <p>
          If the dispute is not resolved within 30 days after notice is received, either party may begin
          arbitration. During this period, any applicable filing deadlines or statutes of limitation will
          be tolled.
        </p>

        <p class="accent">(b) Arbitration Agreement and Exceptions</p>
        <p>Except for:</p>
        <p class="small">1. individual claims that qualify for small claims court, and</p>
        <p class="small">2. disputes relating to intellectual property rights or requests for injunctive or equitable relief,</p>
        <p>
          all disputes ("Disputes") arising out of or related to your use of the Services will be resolved
          by binding arbitration instead of in court.
        </p>
        <p>
          Arbitration will be conducted by Judicial Arbitration and Mediation Services, Inc. (JAMS) in
          accordance with its Comprehensive Arbitration Rules and Procedures.
        </p>
        <p>
          The arbitrator may grant any remedy available in court and the award may be enforced in any court
          of competent jurisdiction.
        </p>
        <p>A request for arbitration ("Request") must include:</p>
        <p class="small">· your name, mailing address, email address, and phone number;</p>
        <p class="small">· a detailed description of the claim and facts supporting it;</p>
        <p class="small">· the remedy sought and a good-faith estimate of damages in U.S. dollars; and</p>
        <p class="small">· a certification that the informal resolution process in Section 12(a) has been completed.</p>
        <p>
          If represented by counsel, the Request must also include counsel's contact information and
          signature.
        </p>
        <p>
          All information exchanged in arbitration proceedings shall remain strictly confidential, except as
          required by law or to enforce an arbitration award.
        </p>

        <p class="accent">(c) Opting Out of Arbitration</p>
        <p>
          You may opt out of this arbitration requirement within 30 days after first accepting these Terms
          by sending written notice to:
        </p>
        <p class="small">SconAI Inc.</p>
        <p class="small">Attn: Legal Department – Arbitration Opt-Out</p>
        <p class="small">1111B S Governors Ave STE 40902</p>
        <p class="small">Dover, DE 19904</p>
        <p class="small">Email: connect@sconai.com</p>
        <p>
          Your notice must include your full name, mailing address, and email address, and must clearly
          state your intent to opt out of binding arbitration.
        </p>
        <p>If you opt out, disputes will be handled in accordance with Section 12(f) below.</p>

        <p class="accent">(d) Rejection of Future Changes</p>
        <p>
          If SconAI later updates this arbitration provision (except for changes to the address or contact
          details), you may reject the update by sending a signed notice to the same address within 30 days
          of the change.
        </p>
        <p>
          If you do, the most recent version of Section 12 before the update will continue to apply.
        </p>

        <p class="accent">(e) Severability</p>
        <p>
          If any part of this Section 12 is found unenforceable or unlawful, that portion shall be severed,
          and the remainder shall remain in full force and effect.
        </p>
        <p>
          Any claims that must proceed on a class or representative basis shall be litigated in a court of
          competent jurisdiction rather than arbitration.
        </p>

        <p class="accent">(f) Waiver of Jury Trial</p>
        <p>
          YOU AND SCONAI HEREBY WAIVE ANY CONSTITUTIONAL OR STATUTORY RIGHT TO A TRIAL BY JURY.
          Except as otherwise provided in this Section, all disputes will be resolved exclusively through
          binding arbitration.
        </p>

        <p class="accent">(g) Waiver of Class and Collective Actions</p>
        <p>
          YOU AND SCONAI AGREE THAT EACH PARTY MAY BRING CLAIMS ONLY IN AN INDIVIDUAL CAPACITY, AND NOT AS
          A PLAINTIFF OR CLASS MEMBER IN ANY CLASS, REPRESENTATIVE, OR COLLECTIVE ACTION.
        </p>
        <p>No consolidated or joint arbitration is permitted.</p>
        <p>
          If a court determines that this limitation is unenforceable as to a particular claim, that claim
          may proceed in court, while all other claims remain subject to arbitration.
        </p>

        <p class="accent">(h) Batch Arbitration</p>
        <p>
          If 100 or more similar arbitration requests are filed within 30 days and are represented by the
          same counsel or group, JAMS will administer them in batches of up to 100 cases per batch
          ("Batch Arbitration").
        </p>
        <p>
          One arbitrator will oversee each batch, and one set of filing and administrative fees will apply
          per side, per batch. This process is designed to streamline resolution and reduce costs.
        </p>
        <p>This clause does not authorize class or collective arbitration.</p>
      </div>

      <!-- Section 13 -->
      <h4 class="accent section-title">13. Governing Law</h4>
      <div class="wrapper-paragraph">
        <p>
          Any claim, dispute, or controversy ("Claim") arising out of or relating to these Terms or the
          Services will be governed by the laws of the State of New York (to the extent not preempted by
          U.S. federal law), without regard to its conflicts-of-law rules that would result in the
          application of any other jurisdiction's laws.
        </p>
        <p>
          If a Claim is not subject to arbitration under Section 12, the state and federal courts located
          in New York City, New York will have exclusive jurisdiction, and you and SconAI waive any
          objection to venue or forum in those courts.
        </p>
        <p>
          If local consumer protection law in your residence requires application of local law and courts,
          this Section applies only to the extent not inconsistent with that requirement.
        </p>
      </div>

      <!-- Section 14 -->
      <h4 class="accent section-title">14. Modifying and Terminating Our Services</h4>
      <div class="wrapper-paragraph">
        <p>
          We may, at any time and without liability, (a) change, limit, replace, upgrade, update, suspend,
          or discontinue any part of the Services; (b) introduce, modify, or waive fees; or (c) make certain
          offers available to some or all users.
        </p>
        <p>
          Unless we state otherwise in writing, any changes or additions to the Services are governed by
          these Terms (and any applicable supplemental terms).
        </p>
        <p>
          We are not responsible for any loss or harm resulting from your inability to access or use the
          Services.
        </p>
      </div>

      <!-- Section 15 -->
      <h4 class="accent section-title">15. Export Control</h4>
      <div class="wrapper-paragraph">
        <p>
          You are solely responsible for complying with all applicable U.S. export control and sanctions
          laws and regulations, including U.S. embargoes and trade restrictions.
        </p>
        <p>You represent and warrant that:</p>
        <p class="small">
          (i) you are not located in, organized under the laws of, or ordinarily resident in any country or
          territory subject to comprehensive U.S. sanctions (including, without limitation, Belarus, Cuba,
          Iran, North Korea, Russia, Syria, and the annexed regions of Ukraine);
        </p>
        <p class="small">
          (ii) you are not identified on any U.S. government restricted or denied-party lists; and
        </p>
        <p class="small">
          (iii) you will comply with all relevant export, re-export, and import laws applicable to your use
          of the Services.
        </p>
      </div>

      <!-- Section 16 -->
      <h4 class="accent section-title">16. Miscellaneous</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Entire Agreement; No Waiver.</p>
        <p>
          Failure by SconAI to enforce any provision of these Terms is not a waiver of that provision. These
          Terms constitute the entire agreement between you and SconAI regarding the Services and supersede
          prior or contemporaneous agreements and understandings on the same subject. Except as expressly
          provided, these Terms do not create rights for any third party. Communications and transactions
          between you and us may be conducted electronically.
        </p>

        <p class="accent">(b) Interpretation.</p>
        <p>
          Section headings are for convenience only and have no legal effect. "Including," "e.g.," and
          similar terms are to be read as "including without limitation." All monetary amounts are in U.S.
          dollars unless stated otherwise. References to URLs include successor URLs, localized versions,
          and content linked from the referenced pages. "Or" is used in the inclusive sense.
        </p>

        <p class="accent">(c) Severability.</p>
        <p>
          If any provision of these Terms is held unlawful or unenforceable, that provision will be severed
          or revised to the minimum extent necessary so that the remainder of the Terms remains in full force
          and effect and reflects, as closely as possible, the parties' original intent.
        </p>

        <p class="accent">(d) Contact; California Notice.</p>
        <p>
          If you have questions or complaints regarding the Services, contact us at connect@sconai.com or by
          mail at:
        </p>
        <p class="small">SconAI Inc.</p>
        <p class="small">1111B S Governors Ave STE 40902</p>
        <p class="small">Dover, DE 19904</p>
        <p>
          Email may not be secure—please do not include payment card data or other sensitive information in
          your messages.
        </p>
        <p>
          Under California Civil Code § 1789.3, California consumers may contact the Complaint Assistance
          Unit of the Division of Consumer Services of the California Department of Consumer Affairs at
          1625 North Market Boulevard, Suite N-112, Sacramento, California 95834, or by phone at
          1 (585) 632-7587.
        </p>
      </div>
    </template>
  </body>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const isKorean = computed(() => locale.value === 'ko');
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.section-title {
  margin: 1.5rem 0 0.5rem 0;
}

.wrapper-paragraph {
  margin: 0 0 1rem 1.5rem;

  .small {
    margin: 0 0 0 1.5rem;
  }
}
</style>
